import superagent from 'superagent';

export default async function postActualizarDomicilio({ jsonBody }) {
  const webserviceURL = process.env.REACT_APP_WEBSERVICE;
  let url = `${webserviceURL}/AvalaraResolveAddress`;
  const domain =
    (window.location.hostname === 'localhost' && 'qa-cart.terramarbrandsusa.com') ||
    window.location.hostname;

  let response = {};

  await superagent
    .post(url)
    .send(jsonBody)
    .set('Content-Type', 'application/json')
    .set('dominio', domain)
    .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
